import type { Tables } from "@msuite/utils/types";
import { UserAvatar } from "../user-card/user-avatar";
import { TicketAssigneePartnership } from "./ticket-assignee-partnership";

/** Props Interface */
interface TicketAssigneeProps {
	ticket: Tables<"tickets">;
}

export function TicketAssignee({ ticket }: TicketAssigneeProps) {
	/** Constants */
	const hasAssignee = ticket.assigneeMember || ticket.assigneePartnership;
	const hasAssigneeMember = ticket.assigneeMember;
	const hasAssigneePartnership = ticket.assigneePartnership;

	/** Guard */
	if (!hasAssignee) return null;

	/** Render */
	if (hasAssigneeMember)
		return (
			<UserAvatar
				userId={ticket.assigneeMember}
				withTooltip
				variant="initials"
			/>
		);

	if (hasAssigneePartnership) {
		return <TicketAssigneePartnership ticket={ticket} />;
	}

	/** Fallback */
	return null;
}
